import { useQuery } from "@apollo/client/react";
import { formatMoneyFromFragment } from "@repo/components/src/utils/money";
import { GetProductSelectionDocument } from "@repo/graphql/documents/product/query.generated";
import React from "react";
import Row from "./row";

type Props = {
  productId: string;
  quantity: number;
};

const ProductRow = React.memo((props: Props) => {
  const { productId, quantity } = props;
  const { data } = useQuery(GetProductSelectionDocument, {
    variables: { id: productId },
  });
  const productFields = data?.product.get;
  return (
    <Row
      name={`${quantity} x ${productFields?.name ?? ""}`}
      value={formatMoneyFromFragment(productFields?.price)}
    />
  );
});

ProductRow.displayName = "ProductRow";

export default ProductRow;
